/**
 * The single status line a contact picker shows when it has no rows to list.
 * Shared by Attorney Questions, Support Tasks quick lookup, Create Task and
 * Template Preview so the four pickers say the same thing.
 */
export const CONTACT_PICKER_MIN_CHARS = 3;

export const contactPickerCanSearch = (query: string): boolean =>
  (query ?? "").trim().length >= CONTACT_PICKER_MIN_CHARS;

export function contactPickerStatus(
  query: string,
  isSearching: boolean,
  isError: boolean,
): string {
  if (!contactPickerCanSearch(query)) {
    return `Type at least ${CONTACT_PICKER_MIN_CHARS} characters`;
  }
  if (isSearching) {
    return "Searching…";
  }
  if (isError) {
    return "Search failed, please try again.";
  }
  return "No matching contacts";
}
